module.exports = __webpack_public_path__ + "static/assets/c36dd943607003a3229aca77b49d32de.mp3";